/**
 * Powered by SuprAI × Frac.
 *
 * The two partner marks, shown as artwork rather than words. The Frac mark
 * always resolves to frac.io; the SuprAI mark goes to the pillar page that
 * explains it. Both files are the artwork supplied by the brand owners.
 *
 * Sizes live in App.css so the lockup can grow on wider screens — the width and
 * height attributes only reserve the aspect ratio.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { useContent } from '../i18n/LocaleProvider';

export const FRAC_URL = 'https://www.frac.io/';

export default function PoweredBy({ variant = 'bar' }) {
  const { UI } = useContent();

  return (
    <div className={`powered-by powered-by--${variant}`} data-testid={`powered-by-${variant}`}>
      <span className="powered-by__label">{UI.common.poweredBy}</span>
      <Link
        to="/our-businesses#suprai"
        className="powered-by__mark"
        aria-label="SuprAI"
        data-testid="powered-by-suprai"
      >
        <img
          src="/brand/suprai-logo-full.webp"
          alt="SuprAI"
          width={2000}
          height={691}
          className="powered-by__img powered-by__img--suprai"
        />
      </Link>
      <span className="powered-by__x" aria-hidden="true">
        ×
      </span>
      <a
        href={FRAC_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="powered-by__mark"
        aria-label="Frac (opens in a new tab)"
        data-testid="powered-by-frac"
      >
        <img
          src="/brand/frac-logo.png"
          alt="Frac"
          width={1871}
          height={400}
          className="powered-by__img powered-by__img--frac"
        />
      </a>
    </div>
  );
}
